module.exports = __webpack_public_path__ + "static/media/DSC02764.a903fa77.jpg";